import "../style/DescriptionSection.css";

const DescriptionSection = () => {
  return (
    <section className="description-section" id="goal">
      <div className="blur-top"></div>
      <div className="blur-bottom"></div>

      <div className="description-content">
        <h4 className="description-title">
          Run Your Jobs, Team & Payments - All From One Dashboard
        </h4>
        <p className="description-text">
         Give employees the tools they need to manage time, leave, documents, and development — all in one place</p>
      </div>
    </section>
  );
};

export default DescriptionSection;
